var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"movie-image"},[_c('img',{attrs:{"src":_vm.srcUrl,"srcset":_vm.srcset,"sizes":_vm.sizes,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }